export const LOAD_WORKSPACE = 'LOAD_WORKSPACE';
export const SAVE_WORKSPACE = 'SAVE_WORKSPACE';
